import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). One fresh die; deal its face value,
 * to the enemy if ≥4 else to self. */
export const WILD_LIGHTNING: Card = {
  id: 'wild-lightning',
  name: 'Wild Lightning',
  type: 'recursive',
  rarity: 'rare',
  size: { w: 1, h: 2 },
  cost: [{ kind: 'min', value: 1 }],
  effects: [
    {
      kind: 'rollFresh',
      count: 1,
      perFace: [
        {
          facePredicate: { kind: 'min', value: 4 },
          effects: [{ kind: 'damage', amount: 0, amountFrom: 'faceValue', target: 'opponent' }],
        },
        {
          facePredicate: { kind: 'max', value: 3 },
          effects: [{ kind: 'damage', amount: 0, amountFrom: 'faceValue', target: 'self' }],
        },
      ],
    },
  ],
};
